import { apiClient } from "@/lib/api-client";

import type { TimeRange, UsageMetrics, UsageMetricsResponse } from "./types";

export async function fetchUsageMetrics(timeRange: TimeRange): Promise<UsageMetrics> {
  const response = await apiClient.get<UsageMetricsResponse>(
    `/assistant/metrics/usage?range=${timeRange}`
  );
  return response.data;
}
